module.exports = __webpack_public_path__ + "static/media/Apercu-Light.15a2727d.woff";